import 'bootstrap-icons/font/bootstrap-icons.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#2967b1',
        success: '#34A853',
        error: '#EA4335',
        warning: '#FBBC05'
      },
      dark: {
        primary: '#444444',
        success: '#34A853',
        error: '#EA4335',
        warning: '#FBBC05'
      }
    }
  },
  icons: {
    iconfont: 'mdi' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
})

export default vuetify
